<template>
  <q-dialog
    :visible="isVisible"
    title="调整记录"
    width="1100px"
    :innerScroll="false"
    :showFooter="false"
    @close="onCancel"
  >
    <div class="dialog-content">
      <div class="record-header">
        <span class="headerText">产品编码：{{ row.productCode }}</span>
        <span class="headerText">产品名称：{{ row.productName }}</span>
      </div>
      <el-table border :data="tableData.records" height="320px" v-loading="loading" :header-cell-style="{ backgroundColor: '#F4F8FB' }">
        <el-table-column :show-overflow-tooltip="true" label="产品编码" prop="productCode" width="140"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="产品名称" prop="productName" min-width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="是否含松木" prop="containsPine" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="是否通知店铺（是否含松木）" prop="noticeStore" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="上市时间" prop="upDate" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="更新人" prop="updatedBy" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="更新时间" prop="updatedDate" width="160"></el-table-column>
      </el-table>
      <div class="footerBox">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
        ></el-pagination>
      </div>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'ProductBaseAttrAdjustRecordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      loading: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    onCancel() {
      this.isVisible = false
    },
    fetchData() {
      this.loading = true
      const data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          productCode: this.row.productCode,
        },
      }
      this.$q.product.productBaseAttrAdjustLog({ data }).then((res) => {
        if (res && res.code == 200 && res.data) {
          const records = res.data.records || res.data.list || []
          this.tableData = {
            records,
            pageNum: res.data.pageNum || this.tableData.pageNum,
            pageSize: res.data.pageSize || this.tableData.pageSize,
            total: res.data.total || 0,
          }
        } else {
          this.tableData.records = []
          this.tableData.total = 0
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.tableData.pageSize = val
      this.tableData.pageNum = 1
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.tableData.pageNum = val
      this.fetchData()
    },
  },
}
</script>

<style lang="stylus" scoped>
.dialog-content
  padding 0 15px 15px

.record-header
  padding-bottom 15px

.headerText
  display inline-block
  padding-right 50px

.footerBox
  text-align right
  padding-top 10px
</style>
